import { gql } from "@apollo/client";

const GET_PROGRAMME = gql`
query programme($programmeID: String, $baseUrl: String)
    {programme(programmeID: $programmeID, baseUrl: $baseUrl) {
        id
        uuid
        status
        title
        code
        programme__ects
        programme__eqf_level_provided
        programme__isced_code
        language_of_instruction
        description
        learning_outcomes
        programme__abbreviation
        programme__elm_lo_type
        programme__elm_learning_schedule
        programme__elm_mode_of_learning
        programme__length
        url
        programme__valid_since
        programme__valid_until
    }  
}`
;

export default GET_PROGRAMME;
